export default __webpack_public_path__ + "static/media/WesbrookVillageMedicalBG.79d7541b.jpg";